import React from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-espresso pt-24 pb-12 border-t border-white/5" dir="rtl" data-id="element-28">
      <div className="container mx-auto px-6 md:px-12" data-id="element-29">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-12 mb-16" data-id="element-30">
          <div className="text-center md:text-right" data-id="element-31">
            <h2 className="font-serif text-4xl text-cream mb-6" data-id="element-32">לוּנה</h2>
            <p className="font-sans text-cream/50 text-sm max-w-xs" data-id="element-33">
              מטבח עילי המשלב מסורת וחדשנות, באווירה אינטימית ומוקפדת בלב תל
              אביב.
            </p>
          </div>

          <div className="flex gap-8" data-id="element-34">
            <a href="#" className="text-cream/50 hover:text-gold transition-colors" data-id="element-35">
              <Instagram size={24} strokeWidth={1.5} data-id="element-36" />
            </a>
            <a href="#" className="text-cream/50 hover:text-gold transition-colors" data-id="element-37">
              <Facebook size={24} strokeWidth={1.5} data-id="element-38" />
            </a>
            <a href="#" className="text-cream/50 hover:text-gold transition-colors" data-id="element-39">
              <Mail size={24} strokeWidth={1.5} data-id="element-40" />
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10 text-cream/40 font-sans text-xs tracking-wider" data-id="element-41">
          <p data-id="element-42">© 2026 לוּנה. כל הזכויות שמורות.</p>
          <div className="flex gap-6 mt-4 md:mt-0" data-id="element-43">
            <a href="#" className="hover:text-cream transition-colors" data-id="element-44">
              תקנון
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-45">
              הצהרת נגישות
            </a>
          </div>
        </div>
      </div>
    </footer>;
}